/* Card image + brand constants, beside the meta copy they travel with.
 * Filenames are versioned because the PNGs are unhashed and both Cloudflare
 * and every social scraper cache them hard: a redesign bumps the number here
 * and in scripts/build-og-cards.mjs together. og:image:alt describes the
 * image, so it moves with the file. */
import { SITE_ORIGIN } from '@/config/routes';
import type { Locale } from '@/strings/types';

export const BRAND: Record<Locale, string> = { en: 'Prinotes', ar: 'برَينوتس' };
export const OG_LOCALE: Record<Locale, string> = { en: 'en_US', ar: 'ar_AR' };
export const CARD_FILE: Record<Locale, string> = {
  en: 'og/prinotes-card-en-v1.png',
  ar: 'og/prinotes-card-ar-v1.png',
};
export const cardUrl = (l: Locale) => `${SITE_ORIGIN}/${CARD_FILE[l]}`;
export const CARD_ALT: Record<Locale, string> = {
  en: 'The Prinotes logo on a light background, above the words: Your conversations & meetings... transcribed and organized in seconds.',
  ar: 'شعار برَينوتس على خلفية فاتحة، وتحته: محادثاتك واجتماعاتك... مفرغة ومنظمة خلال ثوانٍ.',
};
